import * as React from "react";
import { RadiosEditor } from "../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../Process/Process/ProcessComponent";
import { InvestmentPathOptions, PensionPathwayInvestmentOptionArrayBuySellSwitchMap, PensionPathwayInvestmentOptionBuySellSwitchArray, investmentPathOptionsArray, investmentPathOptionsMap} from "../Resource/Content";
import { PensionPathwayInvestmentOption } from "../../../../Wrap/Constants/Enums/PensionPathwayInvestmentOption";
import { PensionArrangementAction } from "../../../Dashboard/Components/Clients/PortfolioDashboard/Components/ProductOverview/Action/PensionArrangementValuationAction";
import { PensionArrangementType } from "../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SelectEditor } from "../../../../react-core/Html/SelectEditor" 
import { Typography } from "../../../Shared/Typography/Typography";

interface IInvestmentPathSelectionProps extends IProcessComponentProps {
    onInvestPathwayChange: (v) => void;
    onCurrentPathwayChange?: (text: string | null) => void; 
}

interface IInvestmentPathSelectionState {
    hasDrawdownArrangement : boolean
}

export class InvestmentPathSelection extends ProcessComponent<IInvestmentPathSelectionProps, IInvestmentPathSelectionState> {
    constructor(props: IInvestmentPathSelectionProps) {
        super(props);
        this.state = {
            hasDrawdownArrangement : false
        }
    }
    
    componentDidMount() {
        const {data} = this.props;
        PensionArrangementAction.GetPensionArrangementDetails(data?.HierarchyId, false, (v) => {
            this.setDrawdownArrangement(v);
        });
    }

    private static validateInvestmentPathwayOptionIsSpecified(v: number): boolean {
        return v != InvestmentPathOptions.NotSpecified;
    }

    private setDrawdownArrangement(arrangementDetails){
        arrangementDetails.forEach(v => {
            if(v.Type != PensionArrangementType.Accumulation){
                this.setState({hasDrawdownArrangement : true});
            }
        });
    }

    private getPathwayTextById(pathwayId: number | null): string | null {
        const selectedPathway = this.props.data?.InvestmentPathwaysSettingsForSettings.find(
            (setting) => setting.InvestmentPathwayQuestionSettingOptionId === pathwayId
        );
        return selectedPathway?.CurrentPathwayInvestmentText || null;
    }    

    private pathwaySettingsConfig = (SelectedPathwayId) => {
        const pathwayText = this.getPathwayTextById(SelectedPathwayId)

        return [
            {
                title: <strong>Selected Investment Pathway:</strong>,
                data: pathwayText
            }
        ];
    }; 

    public render(): JSX.Element
    {
        const { data } = this.props;
        const investmentPathOptionsToChoose = [ InvestmentPathOptions.NotSpecified,
                                                InvestmentPathOptions.NoPlan, 
                                                InvestmentPathOptions.GuaranteeIncome,
                                                InvestmentPathOptions.LongTermIncome,
                                                InvestmentPathOptions.Takeout ]
        return (
            <>
                {this.state.hasDrawdownArrangement && <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Is the transaction linked to Investment Pathway activity?"}
                    selected={!data.InvestmentPathwayAnswers.PersonalRecommendation}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) =>{
                        this.onInvestPathwayChange({ifLinkToInvestmentPath: v})
                    }}
                    required={"Please select"}
                />}

                {!data.InvestmentPathwayAnswers.PersonalRecommendation &&
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"How does the client wish to proceed with the assets in the pension?"}
                    selected={this.props.data.InvestmentPathwayAnswers.InvestmentOption}
                    options={PensionPathwayInvestmentOptionBuySellSwitchArray}
                    getText={(o) => PensionPathwayInvestmentOptionArrayBuySellSwitchMap[o]}
                    onChange={(v) =>{
                        this.onInvestPathwayChange({InvestmentOption: v})
                        
                    }}
                    required={"Please select"}
                />}

                {!data.InvestmentPathwayAnswers.PersonalRecommendation && data.InvestmentPathwayAnswers.InvestmentOption==PensionPathwayInvestmentOption.InvestmentPathway && 
                <SelectEditor
                        cssWrapper="rg-inline mb-16"
                        label={"Which of the below best reflects your investment aims:"}
                        selected={data.InvestmentPathwayAnswers.SelectedPathwayId}
                        options={investmentPathOptionsToChoose}
                        getText={(o) => investmentPathOptionsMap[o]}
                        onChange={(v) => {
                            this.onInvestPathwayChange({ SelectedPathwayId: v })
                        }}
                        validationRules={[
                            {
                                errorMessage: "Please select the one which best reflects your investment aims",
                                validator: InvestmentPathSelection.validateInvestmentPathwayOptionIsSpecified,
                            },
                        ]}
                    />

                }
                {
                    data.InvestmentPathwayAnswers.SelectedPathwayId ? <Typography type="common" config={this.pathwaySettingsConfig(data.InvestmentPathwayAnswers.SelectedPathwayId)} />
                        : null
                }
            
            </>
            );
        }

    private onInvestPathwayChange(v) {
        const { data } = this.props;
        var investmentPathwayAnswers = data.InvestmentPathwayAnswers;

        investmentPathwayAnswers.PersonalRecommendation = v.ifLinkToInvestmentPath!=undefined ? !v.ifLinkToInvestmentPath : investmentPathwayAnswers.PersonalRecommendation
        investmentPathwayAnswers.InvestmentOption = v.InvestmentOption??investmentPathwayAnswers.InvestmentOption;
        investmentPathwayAnswers.SelectedPathwayId = v.SelectedPathwayId??investmentPathwayAnswers.SelectedPathwayId;
        
        if(investmentPathwayAnswers.InvestmentOption != PensionPathwayInvestmentOption.InvestmentPathway)
        {
            investmentPathwayAnswers.SelectedPathwayId=null;
        }

        if(investmentPathwayAnswers.PersonalRecommendation == true)
        {
            investmentPathwayAnswers.InvestmentOption=null;
            investmentPathwayAnswers.SelectedPathwayId=null;
        }

        this.props.onInvestPathwayChange({InvestmentPathwayAnswers : investmentPathwayAnswers});
        
        const pathwayText = this.getPathwayTextById(v.SelectedPathwayId);
        if (this.props.onCurrentPathwayChange) {
            this.props.onCurrentPathwayChange(pathwayText);
        }

    }
}
